export default __webpack_public_path__ + "media/images/halloween/halloween-emblem-04580d924f5ab057d11bc64414cbd455.svg";